import * as React from 'react';

import { withRouter } from 'app/context/Router';
// @ts-ignore
import Button from 'components/ButtonDeprecated';
import Icon from 'components/Icon';
import Link from 'components/Link';
// @ts-ignore
import LinkConstants from 'constants/LinkConstants';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import View from 'components/View';
// @ts-ignore
import Views from 'components/Views';

import EventTracking from 'lib/EventTracking';
// @ts-ignore
import GroupProfileContainer from 'groups/components/GroupProfile';
import ListSidebar, { USER_PROFILE } from 'components/ListSidebar/ListSidebar';
// @ts-ignore
import PendingRolesTableContainer from 'roleRequests/containers/PendingRolesTableContainer';
// @ts-ignore
import { UsersProfileInOrgContainer } from 'users/components/UsersProfile';

import { SidebarData } from 'components/ListSidebar/ListSidebar';
// @ts-ignore
import { UserProfilePartial } from 'users/components/UsersProfile';
import { RoleRequest } from 'roleRequests/components/PendingRolesTable';
// @ts-ignore
import { RouterState } from 'lib/ReactRouterTypes';

type Props = {
  organizationUuid: string;
  userRole: string;
  router: RouterState;
};

type State = {
  sidebarOpen: boolean;
  selectedUser: UserProfilePartial | null;
  reloadQuery: boolean;
  sidebarHistory: SidebarData[];
  currentSidebarData: SidebarData | null;
};

class PendingRolesList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      sidebarOpen: false,
      selectedUser: null,
      reloadQuery: false,
      currentSidebarData: null,
      sidebarHistory: [],
    };
  }

  trackEvent = (key: string) => {
    const { organizationUuid } = this.props;

    EventTracking.trackKey(key, {
      organizationUuid,
    });
  };

  reloadList = () => {
    this.setState(
      {
        reloadQuery: true,
      },
      () => {
        this.setState({
          reloadQuery: false,
        });
      }
    );
  };

  handlePersonClicked = (row: RoleRequest) => {
    this.trackEvent('pending_roles.table.row.click');
    const { user } = row;
    const name = [user.firstName, user.lastName].join(' ');

    this.setState({
      sidebarOpen: true,
      // Add empty fields for missing sidebar data
      selectedUser: { roles: [], grade: null, name, ...user },
      currentSidebarData: null,
      sidebarHistory: [],
    });
  };

  handleViewAllAnnouncementsClicked = () => {
    this.trackEvent('admin_dashboard.pending_roles.profile_view.more_announcements.click');
  };

  handleRemoveGroupFromOrg() {
    this.trackEvent('admin_dashboard.pending_roles.profile_view.remove_from_class.click');
  }

  handleSidebarClose = () => {
    this.setState({
      sidebarOpen: false,
      selectedUser: null,
      currentSidebarData: null,
      sidebarHistory: [],
    });
  };

  handleSidebarEntityClicked = (newSidebarData: SidebarData) => {
    const { sidebarHistory } = this.state;
    const newHistory = sidebarHistory.slice();

    const currentSidebarData = this.getCurrentSidebarData();

    if (currentSidebarData) {
      newHistory.push(currentSidebarData);
    }

    this.setState({ sidebarHistory: newHistory, currentSidebarData: newSidebarData });
  };

  handleSidebarBackClicked = () => {
    const newHistory = this.state.sidebarHistory.slice();
    const sidebarData = newHistory.pop() || null;
    this.setState({ sidebarHistory: newHistory, currentSidebarData: sidebarData });
  };

  getCurrentSidebarData(): SidebarData | null {
    const { organizationUuid } = this.props;
    const { selectedUser, currentSidebarData } = this.state;

    if (currentSidebarData) {
      return currentSidebarData;
    } else if (selectedUser) {
      return {
        type: USER_PROFILE,
        data: {
          member: selectedUser,
          entityUuid: organizationUuid,
        },
      };
    }

    return null;
  }

  renderPageHeader() {
    const { router } = this.props;

    return (
      <MediaObject className="PendingRoles-header">
        <Button
          className="PendingRoles-backButton"
          level="icon"
          weight="semibold"
          aria-label="Back"
          to={router.location.pathname.replace('pending_roles', '')}>
          <Icon name="arrow-left" color="mascot" />
        </Button>
        <TitleHeader
          className="PendingRoles-title"
          title="Pending teacher requests"
          subtext={
            <Text>
              These people have requested approval to be listed as teachers at this school.{' '}
              <Link
                className="PendingRoles-learnMore"
                href={LinkConstants.PENDING_ROLES}
                eventElementName="PendingRoles-learnMore"
                target="_blank">
                Learn more
              </Link>
            </Text>
          }
          textAlign="left"
        />
      </MediaObject>
    );
  }

  render() {
    const { organizationUuid, userRole } = this.props;
    const { sidebarOpen, selectedUser, reloadQuery, sidebarHistory } = this.state;
    const currentSidebarData = this.getCurrentSidebarData();

    return (
      <Views className="PendingRoles">
        <View className="PendingRoles-body" gutter="small" scroll>
          <PendingRolesTableContainer
            organizationUuid={organizationUuid}
            userRole={userRole}
            onPersonClicked={this.handlePersonClicked}
            openUserId={selectedUser ? selectedUser.id : null}
            reloadQuery={reloadQuery}
            pageHeader={this.renderPageHeader()}
            pageHeaderHeight={113}
          />
        </View>
        {sidebarOpen && currentSidebarData && (
          <View className="PendingRoles-sidebar" full scroll>
            <ListSidebar
              sidebarData={currentSidebarData}
              onClose={this.handleSidebarClose}
              reloadQuery={reloadQuery}
              onUserChanged={this.reloadList}
              onEntityClicked={this.handleSidebarEntityClicked}
              onBackClicked={sidebarHistory.length > 0 ? this.handleSidebarBackClicked : undefined}
              onRemoveGroupFromOrg={this.handleRemoveGroupFromOrg}
              onViewAllAnnouncementsClicked={this.handleViewAllAnnouncementsClicked}
              openModalRemoveGroupFromOrgEventKey={
                'admin_dashboard.pending_roles.profile_view.remove_from_school.click'
              }
              userProfileView={UsersProfileInOrgContainer}
              groupProfileView={GroupProfileContainer}
              isAdmin
            />
          </View>
        )}
      </Views>
    );
  }
}

export default withRouter(PendingRolesList);
